( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .service( 'ShipmentDTOCustomService', ShipmentDTOCustomService );

    ShipmentDTOCustomService.$inject = ['$http'];

    function ShipmentDTOCustomService($http) {
        return {
            getLots: getLots,
            getInvoices: getInvoices
        };

        function getLots(id) {
            var url = "api/shipmentDTO/" + id + "/lots";
            return $http.get(url);
        }

        function getInvoices(id) {
            var url = "api/shipmentDTO/" + id + "/invoices";
            return $http.get(url);
        }
    }

})();
